// The turn on screen while Scout works: its text as it streams, and a labelled line per tool step.

import { ChatResponse } from '../components/ChatResponse';
import type { ThreadView } from '../lib/chatFeed.ts';
import { workingLabel } from '../lib/chatFeed.ts';

export function LiveTurn({ view }: { view: ThreadView }) {
  return (
    <div className="chatline assistant chatlive">
      <span className="chatspeaker">Scout</span>
      {view.liveTools.length > 0 ? (
        <ul className="chattools" aria-label="What Scout is doing">
          {view.liveTools.map(tool => (
            <li key={tool.call_id} className={'chattool' + (tool.done ? (tool.ok ? ' done' : ' failed') : ' active')}>
              <span className="chattooldot" aria-hidden="true" />
              {tool.label}
            </li>
          ))}
        </ul>
      ) : null}
      {view.liveText ? <ChatResponse text={view.liveText} streaming /> : null}
      <p className="chatbusy" role="status" aria-live="polite">{workingLabel(view)}</p>
    </div>
  );
}
